
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>So haben wir die Auswahl getroffen</b>
    <p>
  Zu den Berner Gastroriesen zählten wir, wer mehr als drei Restaurants mit
  unterschiedlichen Konzepten in der Stadt Bern betreibt. Bewusst ausgeklammert
  haben wir die Kantinen- und Catering-Grössen wie die SV Group,
  Selbstbedienungsrestaurants der beiden orangen Riesen sowie
  Franchising-Betriebe wie McDonald’s oder Burger King. Der Beitrag entstand
  dank einem Leserhinweis des Tagesanzeiger-Projekts «Was Zürich wissen will».
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;